import * as React from "react";
const SvgFiRrDrumSteelpan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drum-steelpan_svg__a)">
      <path
        fill="#062147"
        d="M24 8.25C24 3.701 18.617 0 12 0S0 3.701 0 8.25v7.393C0 20.251 5.383 24 12 24s12-3.749 12-8.357zM9.484 10.522c.02-.031.49-1.312.512-1.907C10.563 8.871 11.215 9 12 9s1.437-.128 2.004-.385c.021.595.492 1.876.512 1.907.951 1.552 2.601 2.174 4.034 2.406-1.769.973-4.071 1.571-6.549 1.571s-4.78-.598-6.549-1.571c1.432-.232 3.083-.854 4.034-2.406zM22 8.25c0 .986-.388 1.927-1.072 2.766-.507.049-3.55.26-4.678-1.493-.576-1.276-.158-2.266 1.333-5.4l.399-.842C20.404 4.434 22 6.25 22 8.25m-5.908-5.682C14.264 6.209 13.737 7 12 7s-2.262-.787-4.092-4.432A14.8 14.8 0 0 1 12 2c1.448 0 2.836.204 4.092.568m-10.074.713.399.842c1.491 3.135 1.909 4.124 1.333 5.4-1.135 1.765-4.163 1.542-4.678 1.493C2.388 10.177 2 9.236 2 8.25c0-2 1.596-3.816 4.018-4.969M22 15.643C22 19.149 17.514 22 12 22S2 19.148 2 15.643v-2.838C4.151 15.03 7.83 16.5 12 16.5s7.849-1.47 10-3.695z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drum-steelpan_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDrumSteelpan;
